export default "<app-left-nav-container [title]=\"'LEFT_NAVBAR.COMPANY' | translate\" [routes]=\"sideNavRoutes\"></app-left-nav-container>\n"